import React from 'react';
import withStyles from '@mui/styles/withStyles';
import FormLabel from '@mui/material/FormLabel';
import cx from 'classnames';
import Typography from '../Typography';

/**
 * Extension on the FormLabel from material ui adding:
 * - default theme/style
 * - ability so set the label value via the `text` prop
 */
const Label = ({ classes, text, children, className, htmlFor, ...props }) => {
    const content = children || text;
    if (!htmlFor) {
        return (
            <Typography variant="body2" component="span" role="heading" className={className} {...props}>
                {content}
            </Typography>
        );
    }
    return (
        <FormLabel className={cx(classes?.root, className)} htmlFor={htmlFor} {...props}>
            {content}
        </FormLabel>
    );
};

const styles = ({ typography, spacing }) => ({
    root: {
        whiteSpace: 'pre-wrap',
        marginRight: spacing(3),
        ...typography.body2
    }
});

export default withStyles(styles)(Label);
